import { render, staticRenderFns } from "./HomeHowItWorksTabs.vue?vue&type=template&id=0b1f4a36"
import script from "./HomeHowItWorksTabs.vue?vue&type=script&lang=ts"
export * from "./HomeHowItWorksTabs.vue?vue&type=script&lang=ts"
import style0 from "./HomeHowItWorksTabs.vue?vue&type=style&index=0&id=0b1f4a36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports